package com.bikompanion.ui.composables

import androidx.compose.ui.unit.DpOffset
import androidx.compose.ui.unit.dp
import org.maplibre.compose.map.MapState
import org.maplibre.spatialk.geojson.Position
import com.bikompanion.domain.BikeParkingSpot
import com.bikompanion.domain.BikeStation

/** How close a tap has to land to a marker to count as hitting it. */
private val TapSlop = 22.dp

/**
 * The station closest to a tap, or null if the tap landed on bare map.
 *
 * Projecting every station is fine here because it only runs on a click, not per frame.
 */
internal fun List<BikeStation>.nearestTo(
    tap: DpOffset,
    cameraState: MapState,
): BikeStation? {
    val slopSquared = TapSlop.value * TapSlop.value
    var best: BikeStation? = null
    var bestDistance = Float.MAX_VALUE
    forEach { station ->
        val location = cameraState.viewport?.screenLocationFromPosition(
            Position(longitude = station.longitude, latitude = station.latitude),
        ) ?: return@forEach
        val dx = (location.x - tap.x).value
        val dy = (location.y - tap.y).value
        val distance = dx * dx + dy * dy
        if (distance <= slopSquared && distance < bestDistance) {
            best = station
            bestDistance = distance
        }
    }
    return best
}

/** The parking spot closest to a tap, or null if the tap landed on bare map. */
internal fun List<BikeParkingSpot>.nearestTo(
    tap: DpOffset,
    cameraState: MapState,
): BikeParkingSpot? {
    val slopSquared = TapSlop.value * TapSlop.value
    var best: BikeParkingSpot? = null
    var bestDistance = Float.MAX_VALUE
    forEach { spot ->
        val location = cameraState.viewport?.screenLocationFromPosition(
            Position(longitude = spot.longitude, latitude = spot.latitude),
        ) ?: return@forEach
        val dx = (location.x - tap.x).value
        val dy = (location.y - tap.y).value
        val distance = dx * dx + dy * dy
        if (distance <= slopSquared && distance < bestDistance) {
            best = spot
            bestDistance = distance
        }
    }
    return best
}
